(function($){
    $(document).on('click','.burgi',function(){

        $('body').css({ 'overflow':'hidden' });
        $('.holiday-logo-mobile').attr('style', 'display: none !important');
        $('.default-logo').attr('style', 'display: none !important');
        $('.col-cart').attr('style', 'display: none !important');

    });
})(jQuery);

(function($){
    $(document).on('click','.burgi-close',function(){

        $('body').css({ 'overflow':'visible' });
        $('.holiday-logo-mobile').attr('style', 'display: block !important');
        $('.default-logo').attr('style', 'display: block !important');
        $('.col-cart').attr('style', 'display: block !important');

    });
})(jQuery);

(function($){
    $(document).on('click','#wlo-close',function(){

        $('body').css({ 'overflow':'visible' });
        $('.holiday-logo-mobile').attr('style', 'display: block !important');
        $('.default-logo').attr('style', 'display: block !important');
        $('.col-cart').attr('style', 'display: block !important');

    });
})(jQuery);

(function($){
    $(document).on('click','.wlo-btn-wlo-pulse wlo-pulse',function(){

        $('body').css({ 'overflow':'visible' });
        $('.holiday-logo-mobile').attr('style', 'display: block !important');
        $('.default-logo').attr('style', 'display: block !important');
        $('.col-cart').attr('style', 'display: block !important');

    });
})(jQuery);
